import type { optionType } from "utils";

export const filterTypeOptions: optionType[] = [
  { label: "options.typePhotoFilter", value: 0 },
  { label: "options.typeCeremonyMaster", value: 1 },
  { label: "options.typeIntroVideo", value: 2 },
  { label: "options.typeWelcomeVideo", value: 3 },
  { label: "options.typeTextOverlay", value: 4 },
];

export const deviceStatusOptions: optionType[] = [
  { value: 0, label: "deviceStatusActive" },
  { value: 1, label: "deviceStatusNew" },
  { value: 2, label: "deviceStatusUnderMaintance" },
  { value: 3, label: "deviceStatusDeleted" },
];

export const couponTypeOptions: optionType[] = [
  { value: 0, label: "percentDiscount" },
  { value: 1, label: "fixedAmountDiscount" },
];

export const eventTypeOptions: optionType[] = [
  { value: 0, label: "Wedding" },
  { value: 1, label: "BabyShower" },
  { value: 2, label: "Birthday" },
  { value: 3, label: "BachelorAndBacheloretteParty" },
  { value: 6, label: "Other" },
  { value: 7, label: "CompanyEvent" },
];

export const paymentOptions: optionType[] = [
  { value: 0, label: "paymentNotPayed" },
  { value: 1, label: "paymentDeposit" },
  { value: 2, label: "paymentPayed" },
  { value: 3, label: "paymentRefunded" },
  { value: 4, label: "devicePaidDepositNot" },
  { value: 5, label: "paymentGratis" },
  { value: 6, label: "paymentPending" },
  { value: 7, label: "bookingCancelled" },
];

export const hearAboutUsOptions: optionType[] = [
  { value: 0, label: "hearAboutUsTypeFacebook" },
  { value: 1, label: "hearAboutUsTypeInstagram" },
  { value: 2, label: "hearAboutUsTypeTiktok" },
  { value: 3, label: "hearAboutUsTypeFriend" },
  { value: 4, label: "hearAboutUsTypeWeddingExhibition" },
  { value: 5, label: "hearAboutUsTypeOther" },
  { value: 6, label: "hearAboutUsTypePinterest" },
  { value: 7, label: "hearAboutUsTypeWeddingPlanner" },
];

export const aspectRatioOptions: optionType[] = [
  { value: 0, label: "16x9" },
  { value: 1, label: "1x1" },
  { value: 2, label: "9x16" },
  { value: 3, label: "4x3" },
  { value: 4, label: "3x4" },
];

export const showGalleryStatusOptions: optionType[] = [
  { value: 0, label: "noShowGalleryStatus" },
  { value: 1, label: "onlyPhoto" },
  { value: 2, label: "photoAndVideo" },
];

export const wifiOptions: optionType[] = [
  { value: "0", label: "RPI" },
  { value: "1", label: "USB" },
];

export const lteModemOptions: optionType[] = [
  { value: 0, label: "no" },
  { value: 1, label: "yes" },
  { value: 2, label: "yesGps" },
];

export const batteryOptions: optionType[] = [
  { value: 0, label: "no" },
  { value: 1, label: "mah12000" },
  { value: 2, label: "mah14000" },
  { value: 3, label: "mah21000" },
];

export const cameraOptions: optionType[] = [
  { value: "0", label: "75*CSI" },
  { value: "1", label: "80*USB" },
  { value: "2", label: "120*CSI" },
  { value: "3", label: "120*USB" },
  { value: "4", label: "135*USB" },
];

export const coolingOptions: optionType[] = [
  { value: "0", label: "active" },
  { value: "1", label: "passive" },
];

export const powerOptions: optionType[] = [
  { value: 0, label: "RPI" },
  { value: 1, label: "MerryKing" },
];

export const forkHolderOptions: optionType[] = [
  { value: 0, label: "original" },
  { value: 1, label: "old" },
  { value: 2, label: "new" },
];

export const deviceBugOptions: optionType[] = [
  { value: 0, label: "empty" },
  { value: 1, label: "known" },
  { value: 2, label: "inProgress" },
  { value: 3, label: "closed" },
];

export const mobileTypeOptions: optionType[] = [
  { value: 0, label: "no" },
  { value: 1, label: "topUpcard" },
  { value: 2, label: "subscription" },
];

export const cameraCableOptions: optionType[] = [
  { value: 0, label: "-" },
  { value: 1, label: "normal" },
  { value: 2, label: "shaded" },
];

export const cameraPhotoResolutionOptions: optionType[] = [
  { value: 0, label: "resolutionNotSet" },
  { value: 0x09000510, label: "resolution2k" },
  { value: 0x12000a20, label: "resolution4k" },
];

export const audioSettingsOptions: optionType[] = [
  { value: 0, label: "percent_0" },
  { value: 10, label: "percent_10" },
  { value: 20, label: "percent_20" },
  { value: 30, label: "percent_30" },
  { value: 40, label: "percent_40" },
  { value: 50, label: "percent_50" },
  { value: 60, label: "percent_60" },
  { value: 70, label: "percent_70" },
  { value: 80, label: "percent_80" },
  { value: 90, label: "percent_90" },
  { value: 100, label: "percent_100" },
];

export const aiPhotoResolutionOptions: optionType[] = [
  { value: 1, label: "resolution720p" },
  { value: 2, label: "resolution1080p" },
  { value: 3, label: "resolution768p" },
];

export const aiPhotoGenerateOptions: optionType[] = [
  { value: 1, label: "gen4ImageTurbo" },
  { value: 2, label: "gen4Image" },
  { value: 3, label: "gemini25Flash" },
];
